import api from "./client";

export const resultsService = {
    yesterday: () => api.get("/results/yesterday").then((r) => r.data),
    byDate: (iso) => api.get(`/results/date/${iso}`).then((r) => r.data),
    recent: (days = 7) =>
        api.get(`/results/recent?days=${days}`).then((r) => r.data),
};
